import { ProbableIncident } from '@mobile/ActionQueue/Actions/Incidents/ProbableIncident'
import { IncidentDetailsFillState } from '@mobile/views/Relation/DetailsPanel/enums'

import { getIncidentDetailsFillState as _getIncidentDetailsFillState } from '../components/ExpectedGoals'
import { groups } from './consts'

export function getIncidentDetailsFillState(incident: ProbableIncident): {
  state: IncidentDetailsFillState
} {
  return _getIncidentDetailsFillState(groups, incident)
}
